import Resize from "../utils/Resize";
export default class AlignManager {
    constructor(rows, cols) {
        this.rows = rows;
        this.cols = cols;
    }
    getCellSize() {
        const size = window.getGameSize();
        const width = size.width;
        const height = size.height;
        const cellWidth = width / this.cols;
        const cellHeight = height / this.rows;
        this.width = width;
        this.height = height;
        this.cellWidth = cellWidth;
        this.cellHeight = cellHeight;
        return { width, height, cellWidth, cellHeight };
    }
    placeIconsMenuAtXY(x, y, iconId) {
        let scaleCanvasResult = Resize.scaleCanvas();
        const offsetX = (scaleCanvasResult.viewportWidth - scaleCanvasResult.scaledWidth) / 2;
        const offsetY = (scaleCanvasResult.viewportHeight - scaleCanvasResult.scaledHeight) / 2;
        const el = document.getElementById(iconId);
        if (el) {
            el.style.position = 'absolute';
            el.style.transform = `scale(${scaleCanvasResult.scale})`;
            el.style.left = `${x * scaleCanvasResult.scale + offsetX}px`;
            el.style.top = `${y * scaleCanvasResult.scale + offsetY}px`;
            el.style.transform = 'translate(-50%, -50%)';
            el.style.zIndex = '10';
        }
    }
    placeFooterBar(iconId) {
        const scaleCanvasResult = Resize.scaleCanvas();
        const offsetX = (scaleCanvasResult.viewportWidth - scaleCanvasResult.scaledWidth) / 2;
        const offsetY = (scaleCanvasResult.viewportHeight - scaleCanvasResult.scaledHeight) / 2;
        const el = document.getElementById(iconId);
        if (!el)
            return;
        // ⚠️ NON settiamo width/height da JS
        const centerX = offsetX + scaleCanvasResult.scaledWidth / 2;
        // 👇 qui NON sappiamo altezza JS → usiamo offset "visivo"
        const bottomY = offsetY + scaleCanvasResult.scaledHeight;
        el.style.position = 'absolute';
        el.style.left = `${Math.round(centerX)}px`;
        el.style.top = `${Math.round(bottomY)}px`;
        // 👇 trick: agganci il footer al bottom via transform
        el.style.transform = 'translate(-50%, -100%)';
        el.style.zIndex = '5';
    }
}
